@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
@if (!loading) {
  <table [dataSource]="ticketData" mat-table>
    <ng-container matColumnDef="id">
      <th *matHeaderCellDef mat-header-cell>Ticket Id</th>
      <td *matCellDef="let row" mat-cell> {{ row.id }}</td>
    </ng-container>
    <ng-container matColumnDef="ticketStatus">
      <th *matHeaderCellDef mat-header-cell>Status</th>
      <td *matCellDef="let row" mat-cell> {{ row.ticketStatus }}</td>
    </ng-container>
    <ng-container matColumnDef="skillProfile">
      <th *matHeaderCellDef mat-header-cell>Skills</th>
      <td *matCellDef="let row" mat-cell>@for (skillRule of row.skillProfile.skillRuleList; track skillRule) {
        <span
        >{{ skillRule.skill.description }}</span>
      }</td>
    </ng-container>
    <ng-container matColumnDef="resourceAvailability">
      <th *matHeaderCellDef mat-header-cell>Resource</th>
      <td *matCellDef="let row"
        mat-cell> {{ row.resourceAvailability ? row.resourceAvailability.resource.name : 'Not assigned' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="startTime">
      <th *matHeaderCellDef mat-header-cell>Start Time</th>
      <td *matCellDef="let row" mat-cell> {{ row.startTime | amDateFormat : 'DD/MM/YYYY HH:mm' }}</td>
    </ng-container>
    <ng-container matColumnDef="duration">
      <th *matHeaderCellDef mat-header-cell>Duration</th>
      <td *matCellDef="let row" mat-cell> {{ row.duration }} minutes</td>
    </ng-container>
    <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
    <tr *matRowDef="let row; columns: displayedColumns;" mat-row>
    </table>
  }
